module.exports = __webpack_public_path__ + "fonts/ocStNKbF.woff2";